<template>
    <Motion
      :initial="{ opacity: 0, y: 50 }"
      :animate="{ opacity: 1, y: 0 }"
      :transition="{ duration: 0.7, delay: 0.5, type: 'spring', stiffness: 80 }"
    >
      <div class="bg-gradient-to-r from-yellow-100/80 to-amber-100/80 rounded-xl p-6 md:p-8 shadow-lg">
        <div class="flex items-center justify-center gap-3 mb-6">
          <v-icon color="amber" size="28">mdi-duck</v-icon>
          <h2 class="text-2xl font-bold text-slate-800 ">Other Ducks to Find</h2>
        </div>
        
        <DucksList class="mt-4" />
        
        <div class="text-center mt-8">
          <p class="text-sm text-gray-600 ">
            There are more ducks hidden around! Keep your eyes open.
          </p>
        </div>
      </div>
    </Motion>
  </template>
  
  <script setup lang="ts">
  import { Motion } from 'motion-v';
  import DucksList from "@/components/demoduckview/DucksList.vue";
  </script>